import Api from 'src/util/api';
import { PageDo, Result, ResultPageDo, Integer, PageResDo } from 'src/types/base';

export declare namespace DataManagementDOI{
    export interface RowDataI {
        id: number;
        file_name: string;
        data_url: string;
    }

    export interface MyRowDataI{
        id: number;
        file_name: string;
    }

    export interface QueryRowDataParamsI extends PageDo {
        type: Integer;
        data_id?: number;
    }

    export interface AddData {
        id?: number;
        file_name: string;
        access_level: number;
        data_id: number;
        data_url: string;
        type: number;
    }
}


export default class DataManagementApi {
    /**
     * 用户查询资料
     * @param {DataManagementDOI.QueryRowDataParamsI} params 
     * @returns 
     */
    static async userQueryList(params: DataManagementDOI.QueryRowDataParamsI):Promise<Result<DataManagementDOI.RowDataI[]>>{
        return Api.post('/management/query/data', {
            ...params,
        });
    }
    
    /**
     * 
     * @returns 查询资料类别
     */
    static async searchDataCategories():Promise<Result<{id: int, data_name: string}[]>> {
		return Api.post('/management/data_categories/query')
    }
    
    /**
     * 根据用户角色id查询资料类别
     */
    static async searchDataCategoriesById():Promise<Result<{id: int, data_name: string}[]>> {
        return Api.post('/management/role_id/by/query')
    }

    /**
     * 新增资料
     * @param params 
     */
    static async add(params: DataManagementDOI.AddData):Promise<Result<any>>{
       return Api.post('/management/add/data', params)
    }

    /**
     * 
     * @param id 删除资料
     */
    static async delete(id: number): Promise<Result<any>>{
        return Api.post('/management/delete/data', {id: id})
    }
    
    /**
     * 
     * @param params 查询个人发布资料
     */
    static async queryMyData(params: DataManagementDOI.QueryRowDataParamsI):Promise<Result<DataManagementDOI.MyRowDataI[]>>{
       return Api.post('/management/query/my/data', {
           ...params,
       })
    }
}